import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';

import { FuseSharedModule } from '@fuse/shared.module';

import { FaqComponent } from './faq.component';
import { FaqAnswerComponent } from './dialogs/answer.component';

import { FaqService } from '@fuse/services/faq/faq.service';

import { MatIconModule, MatButtonModule, MatTableModule, MatCheckboxModule, MatMenuModule, MatPaginatorModule, MatSortModule, MatToolbarModule, MatFormFieldModule, MatDatepickerModule, MatInputModule, MatSnackBarModule } from '@angular/material';

const routes = [
    {
        path: 'faq',
        component: FaqComponent
    }
];

@NgModule({
    declarations: [
        FaqComponent,
        FaqAnswerComponent
    ],
    imports: [
        RouterModule.forChild(routes),

        TranslateModule,

        FuseSharedModule,
        
        MatDialogModule,
        MatListModule,
        MatIconModule,
        MatButtonModule,
        MatTableModule,
        MatCheckboxModule,
        MatMenuModule,
        MatPaginatorModule,
        MatSortModule,
        MatToolbarModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatInputModule,
        MatSnackBarModule
    ],
    providers: [
        FaqService
    ],
    exports: [
        FaqComponent
    ],
    entryComponents: [
        FaqAnswerComponent
    ]
})

export class FaqModule {
}
